import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import vuetify from "./plugins/vuetify"
import {getModule} from "vuex-module-decorators"
import DeploymentStore from "@/store/deployment"
import VueLuxon from "vue-luxon";

Vue.config.productionTip = false
Vue.use(VueLuxon);

export const BASE_PATH = "/api/v0"

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount("#app")

const deploymentStore = getModule(DeploymentStore)
deploymentStore.pollResources()
deploymentStore.pollDeployments()
